<ds-modal
  [modal]="modal"
  [title]="options.headerKey | translate"
  [maxWidthPercentage]="50"
  [closeAllModals]="closeAllModals"
  (modalClosed)="onClose()"
>
  <div class="text-black">
    <div class="row">
      <p class="col-auto">
        {{ options.descriptionKey | translate: options.descriptionParams }}
      </p>
    </div>
    <div class="row">
      <div class="col-auto">
        <p class="mb-1">{{ options.listHeaderKey | translate }}</p>
        <ul>
          @for (item of options.listItems; track $index) {
            <li [innerHTML]="formatListItem(item)"></li>
          }
        </ul>
      </div>
    </div>
    <div class="row mb-4">
      <div class="col-12">
        <form [formGroup]="form">
          <app-common-input [form]="form" [formValidationRequest$]="formValidationRequest$" [context]="nameInputContext">
          </app-common-input>
        </form>
      </div>
    </div>
  </div>
  <ds-button-group
    [primaryAction]="{ label: options.confirmButtonKey | translate }"
    [secondAction]="{ label: options.cancelButtonKey | translate, variant: DsButtonVariants.secondary }"
    (primaryActionClicked)="onConfirm()"
    (secondActionClicked)="onCancel()"
  >
  </ds-button-group>
</ds-modal>
